document.addEventListener("DOMContentLoaded", function () {
    initWishlist();  
});


function initWishlist(section = false){
  if (!localStorage.getItem("wishlist")) {
    localStorage.setItem("wishlist", JSON.stringify([])); // Inicializa una lista vacía
  }
  let listaFavoritosGuardados = obtenerWishlist();
  if(!section){
    let favoritos = document.querySelectorAll(".z-add-to-whishlist");
    favoritos.forEach((boton) => {
      let productsId = boton.getAttribute("data-product-id");
      if (listaFavoritosGuardados.findIndex(item => item.productsId === productsId) > -1) {
        document.querySelector("#fav-" + productsId + " > .icon").style.color = "black";
        document.querySelector("#fav-" + productsId + " > .icon").style.fill = "yellow";
        // document.querySelector('wishlist-dot').classList.add("is-visible");
      }
      boton.addEventListener("click", function (e) {
        agregarProductoAWishlist(productsId);
      });
    });
  }else{
    let favoritos = section.querySelectorAll(".z-add-to-whishlist");
    favoritos.forEach((boton) => {
    let productsId = boton.getAttribute("data-product-id");
     if (listaFavoritosGuardados.findIndex(item => item.productsId === productsId) > -1) {
        section.querySelector("#fav-" + productsId + " > .icon").style.color = "black";
        section.querySelector("#fav-" + productsId + " > .icon").style.fill = "yellow";
      }
      boton.addEventListener("click", function (e) {
        agregarProductoAWishlist(productsId);
      });
    });
  }
}

function agregarProductoAWishlist(productoId) {
  let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
  // console.log(wishlist.findIndex(item => item.productsId === productoId))
  if (wishlist.findIndex(item => item.productsId === productoId) < 0) {
    // Verifica duplicados
    // console.log("add to wishlist", productoId);
    wishlist.push({'sort': Date.parse(new Date()), 'productsId' : productoId });
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
    document.querySelector("#fav-" + productoId + " > .icon").style.color = "black";
    document.querySelector("#fav-" + productoId + " > .icon").style.fill = "yellow";
  } else {
    // console.log("remove from wishlist", productoId);
    document.querySelector("#fav-" + productoId + " > .icon").style.color = "black";
    document.querySelector("#fav-" + productoId + " > .icon").style.fill = "transparent";
    eliminarProductoDeWishlist(productoId);
  }
}

function eliminarProductoDeWishlist(productoId) {
    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    const index = wishlist.findIndex(item => item.productsId === productoId); // Encuentra el índice del producto
  
    if (index > -1) {
      // Solo si el producto existe en la wishlist
      wishlist.splice(index, 1); // Elimina el producto
      localStorage.setItem("wishlist", JSON.stringify(wishlist));
    }
}

function obtenerWishlist() {
  return JSON.parse(localStorage.getItem("wishlist")) || [];
}


export { initWishlist };